import { jsonProperty, Serializable } from 'ts-serializable';

export default class DeleteMessageDto extends Serializable {
  @jsonProperty(Number, null) documentTypeId: number | null = null;
  @jsonProperty(Number, null) documentId: number | null = null;
  @jsonProperty(Number, null) messageId: number | null = null;
}
